export default {"src":"/_next/static/media/caves.c579e559.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};